import React,{useState, useEffect} from 'react'
import styled from 'styled-components';
import CreateTemplate from '../Components/CreateTemplate/CreateTemplate'
import { useSelector, useDispatch } from "react-redux";
import { setEsDownFlagTemp, setEsDownFlagDoc, getDefaultManufacturersRedis, getClientByID, getUsersManufacturers, getCategoriesWithLineitemsRedis, elasticSearchFetchDoc, elasticSearchCreateDocOrTemp, elasticSearchFetchTemp, getDefaultManufacturer, getDefaultCategories, getCategoryByUserID, getUnits, getTemplate, getDocumentByID, getDocumentWorkOrderData, getDocumentEstimateData, getDocOrderIds, addDocOrders} from '../graphql/queries';
import Amplify, { API, graphqlOperation } from 'aws-amplify';
import config from '../aws-exports';
import * as queryString from "query-string";
import Loader from './../assets/loading.gif';
import ToastBox from '../Components/Toast/Toast';
import { Helmet } from 'react-helmet';
import  secureLocalStorage  from  "react-secure-storage";
import Sync from "./../assets/sync.gif";
import {apiCallWithSubscription} from '../Components/CommonComponents/helper.js';
import {getDateTimeV2} from '../Components/CommonComponents/helper.js';
Amplify.configure(config);

export default function MainCreateTemplate(props) {
    const {consoleLog} = require('../Components/commonFunctions.js');
    console.log("MainCreateTemplate props: ", props);

    const url_params = queryString.parse(props.location.search);
    const prevState = props.location && props.location.state && props.location.state.error ? props.location.state.error : false;
    console.log("MainCreateTemplate url_params: ", url_params )

    const [templateInfo, setDocType] = React.useState(useSelector((state) => state.templateInfo));
    const [stData, setStData] = React.useState(useSelector((state) => state.templateStructure));
    const [default_category, setDCategory] = React.useState(useSelector((state) => state.defaultCategories));
    const [category_by_user_id, setDCategoryByUserId] = React.useState(useSelector((state) => state.getCategoryByUserID));
    const [defaultCategory, setUserDefaultCategory] = React.useState(useSelector((state) => state.defaultCategories));
    const [userCategory, setUserCategory] = React.useState(useSelector((state) => state.getCategoryByUserID));
    const [defaultManufacturers, setDefaultManufacturers] = React.useState(useSelector((state) => state.defaultManufacturer));
    const [userManufacturers, setUserManufacturers] = React.useState([]);
    const [d_manf, setDMan] = React.useState(useSelector((state) => state.defaultManufacturer));
    const [loading, setLoading] = useState(true);
    const [loading2, setLoading2] = useState(false);

    const [show, setShow] = useState(false);
    const [showMessage, setShowMessage] = useState('');
    const [showMessageType, setShowMessageType] = useState('');

    const [synching, setSynching] = useState(false);
    const showSynching = async () => {
        setSynching(true);
        await new Promise((resolve) => setTimeout(resolve, 2000));  // Simulate save delay
        setSynching(false);
    };

    const dispatch = useDispatch();

    useEffect(()=>{
        const fetchData = async () => {
            let doc_type_id = url_params.doc_type_id ? url_params.doc_type_id : null;
            let doc_id = url_params.doc_id ? url_params.doc_id : null;
            
            fetchUnits();
            fetchCategories();
            fetchDefaultManufacturer();
            await fetchTemplateRecord(url_params.template_id, doc_type_id, doc_id);
        }
        fetchData();
    }, []);


    async function fetchTemplateRecord(template_id, doc_type_id, doc_id){
        console.log("fetch record of template: " + template_id + ", doc_type_id: " + doc_type_id+" doc_ic"+doc_id);
        try {
            let template_record = {};
            let template_info = templateInfo;
            let allData = stData;
            let doc_found = false;
            let temp_found = false;
            let es_down_docs = [];
            let es_down_temps = [];
            ////Check if this document / template was edited when ES down
            if(doc_id){
                console.log('es_down_docs>',secureLocalStorage.getItem("es_down_docs"));
                try {
                    let rawEs = secureLocalStorage.getItem("es_down_docs");
                    let parsedEs = rawEs ? (typeof rawEs === 'string' ? JSON.parse(rawEs) : rawEs) : null;
                    es_down_docs = parsedEs?.body?.docs || [];
                } catch (e) {
                    console.error("Error reading es_down_docs:", e);
                    es_down_docs = [];
                }
                console.log('es_down_docs>>>', es_down_docs);
                for (let index = 0; index < es_down_docs.length; index++) {
                    if(es_down_docs[index].doc_id == doc_id){
                        doc_found = true;
                        break;
                    }
                }
                console.log('es_down_docs doc_found>>>', doc_found);
            }else{
                try {
                    let rawEs = secureLocalStorage.getItem("es_down_docs");
                    let parsedEs = rawEs ? (typeof rawEs === 'string' ? JSON.parse(rawEs) : rawEs) : null;
                    es_down_temps = parsedEs?.body?.temps || [];
                } catch (e) {
                    console.error("Error reading es_down_temps:", e);
                    es_down_temps = [];
                }
                console.log('es_down_docs>>>', es_down_temps);
                for (let index = 0; index < es_down_temps.length; index++) {
                    if(es_down_temps[index].template_id == template_id){
                        temp_found = true;
                        break;
                    }
                }
                console.log('es_down_docs temp_found>>>', temp_found);
            }
            ////
            if(doc_type_id == 2){   //  will run in case of Document Work Order
                showSynching();
                console.log('PO >> elasticSearchFetchDoc lambda called at ' + getDateTimeV2());
                template_record = await API.graphql({
                    query: elasticSearchFetchDoc,
                    variables: {
                        doc_id: doc_id
                    }
                });

                console.log("PO GraphQL >> elasticSearchFetchDoc >> response ",template_record)
                let template_record_rep = template_record;
                // Log the raw response to inspect the structure
                console.log("PO Raw elasticSearchFetchDoc response: ", template_record_rep.data.elasticSearchFetchDoc);

                // First, parse the outer string to get the inner JSON
                let unescapedResponse = JSON.parse(template_record_rep.data.elasticSearchFetchDoc);

                // Log the unescaped response to check the structure
                console.log("PO Unescaped Response: ", unescapedResponse);

                // Second, parse the inner JSON to get the actual data
                let parsedData = JSON.parse(unescapedResponse);  // Parse the actual data inside
     
                console.log('PO elasticSearchFetchDoc lambda response received at ' + getDateTimeV2());
                let template_status = JSON.parse(JSON.parse(template_record.data.elasticSearchFetchDoc)).status;
                template_record = JSON.parse(JSON.parse(template_record.data.elasticSearchFetchDoc)).data;

                if (
                    parsedData &&
                    parsedData.hasOwnProperty('data') &&
                    parsedData.data &&
                    parsedData.data.hasOwnProperty('data')
                 ) {
                    template_record = parsedData.data.data;
                 }
               
                allData = template_record;
                console.log('PO template_record es 2', template_record);
                console.log('PO template_record es 2 status', template_record, template_status);
                //if document is not in elasticsearch or need to import the doc
                if(Object.keys(template_record).length == 0 || template_record.create_on_elasticsearch == 1 || doc_found){
                    console.log('PO template_record es x');
                    showSynching();
                    console.log('PO apiCallWithSubscription elasticSearchCreateDocOrTemp lambda called at ' + getDateTimeV2());
                    allData = await apiCallWithSubscription({doc_id: doc_id} ,"getDocumentWorkOrderData");
                    console.log('PO apiCallWithSubscription elasticSearchCreateDocOrTemp lambda response received at ' + getDateTimeV2());
                    console.log("PO template_record db 2: ", allData);

                    if( allData.hasOwnProperty('data') ) {
                        allData = allData.data;
                    }
                    console.log('PO template_record', allData);
                    console.log('PO template_record', allData.user_id);
                    console.log('PO template_record', allData.team_id);
                    console.log('PO template_record', doc_id);

                    let doc_data = JSON.stringify(allData);

                    console.log("PO template_record doc_data", doc_data);

                    if(template_status != 500){ //create on ES if ES is not down
                        try {
                            console.log('PO elasticSearchCreateDocOrTemp lambda called at ' + getDateTimeV2());
                            const save_elastic_es = API.graphql({
                                query: elasticSearchCreateDocOrTemp,
                                variables: {
                                    id: doc_id,
                                    index: 'prodocs-documents',
                                    template: doc_data
                                }
                            });
                            console.log('PO elasticSearchCreateDocOrTemp lambda response received at ' + getDateTimeV2());
                            console.log('PO template_record save_elastic_es', save_elastic_es);
                        } catch (err) {
                            console.error(err);
                        }
                        if(es_down_docs.length > 0){
                            let x = es_down_docs.find(d =>d.doc_id == doc_id);
                            console.log('es_down_docs x>>>', x);
                            if(x?.es_down_flag == '1'){
                                let temp_docs = es_down_docs.filter(d =>d.doc_id != doc_id);
                                console.log('es_down_docs temp_docs>>>', temp_docs);

                                let rawEs = secureLocalStorage.getItem("es_down_docs");
                                let temp_docs_temp = rawEs ? (typeof rawEs === 'string' ? JSON.parse(rawEs) : rawEs) : { body: { docs: [] } };
                                if (temp_docs_temp && temp_docs_temp.body) {
                                  temp_docs_temp.body.docs = temp_docs;
                                  secureLocalStorage.setItem('es_down_docs', JSON.stringify(temp_docs_temp));
                                }
                                //now set es flag off in db
                                console.log('setEsDownFlagDoc lambda called at ' + getDateTimeV2());
                                const set_flag_off = API.graphql({
                                    query: setEsDownFlagDoc,
                                    variables: {
                                        doc_id: doc_id,
                                        flag: '0'
                                    }
                                });
                                console.log('setEsDownFlagDoc lambda response received at ' + getDateTimeV2());
                            }
                        }
                    }
                    await saveQuantities(doc_id, doc_type_id, doc_data, allData);
                    
                }else{
                    console.log('template_record allData', allData);
                    allData.structures = template_record.structures;
                    if(typeof template_record.markups == 'string'){
                        allData.markups = JSON.parse(template_record.markups);
                    }else{
                        allData.markups = template_record.markups;
                    }
                    allData.notes = template_record.notes;
                    allData.options = template_record.options;
                    allData.footer = template_record.footer;
                    allData.label = template_record.label;
                    allData.team_id = template_record.team_id;
                    allData.user_id = template_record.user_id;
                    console.log('template_record str', template_record.structures);
                    console.log('template_record allDatax', allData);
                }
                template_info = {
                    "template_id": template_id,
                    "doc_type_id" : doc_type_id,
                }
                
                allData.doc_id = doc_id;
                let client_id = JSON.parse(secureLocalStorage.getItem("client_data")).client_id;
                let team_id = JSON.parse(secureLocalStorage.getItem("client_data")).team_id;
                let team_role = JSON.parse(secureLocalStorage.getItem('client_data')).team_role;
                let leader_id = JSON.parse(secureLocalStorage.getItem("client_data")).leader_id;

                console.log('template_recordz', client_id);
                console.log('template_recordz', team_id);
                console.log('[TEMPLATE team_id '+allData.team_id+' and CLIENT team_id '+team_id+' ]');

                if (team_role === 'Leader' || team_role === 'Admin') {
                    console.log(`AUTHORIZATION_ALERT_ERROR: Role is '${team_role}'. Checking if user's team (${team_id}) matches template team (${allData.team_id})...`);
                    if (allData.team_id !== team_id) {
                        console.error(`AUTHORIZATION_ALERT_ERROR: Authorization failed. ${team_role} is trying to access a template from another team.`);
                        alert('You are not authorized to access this Template.');
                        setLoading(false);
                        return false;
                    }
                } else if ((team_role === '' || team_role === null) && client_id === leader_id) {
                    console.log(`AUTHORIZATION_ALERT_ERROR: No team_role but user is leader (client_id: ${client_id}, leader_id: ${leader_id}).  Checking team ownership...`);
                    if (allData.team_id !== team_id) {
                        console.error(`AUTHORIZATION_ALERT_ERROR: Authorization failed. Leader with no role is trying to access a template from another team.`);
                        alert('You are not authorized to access this Template.');
                        setLoading(false);
                        return false;
                    }
                } else {
                    console.log(`AUTHORIZATION_ALERT_ERROR: Standard user access check. Comparing template owner user_id (${allData.user_id}) with current client_id (${client_id})...`);
                    if (allData.user_id !== client_id) {
                        console.error(`AUTHORIZATION_ALERT_ERROR: Authorization failed. User ${client_id} is attempting to access a template owned by ${allData.user_id}.`);
                        alert('You are not authorized to access this Template.');
                        setLoading(false);
                        return false;
                    }
                }
            }else if(doc_type_id == 1){ //  will run in case of Document Estimate
                showSynching();
                console.log('elasticSearchFetchDoc lambda called at ' + getDateTimeV2());
                template_record = await API.graphql({
                    query: elasticSearchFetchDoc,
                    variables: {
                        doc_id: doc_id
                    }
                });
                console.log("Graph QL response ",template_record)
                let template_record_rep = template_record;
                  // Log the raw response to inspect the structure
                  console.log("Raw elasticSearchFetchDoc response: ", template_record_rep.data.elasticSearchFetchDoc);

                  // First, parse the outer string to get the inner JSON
                  let unescapedResponse = JSON.parse(template_record_rep.data.elasticSearchFetchDoc);
      
                  // Log the unescaped response to check the structure
                  console.log("Unescaped Response: ", unescapedResponse);
      
                  // Second, parse the inner JSON to get the actual data
                  let parsedData = JSON.parse(unescapedResponse);  // Parse the actual data inside
      
            
                console.log('elasticSearchFetchDoc lambda response received at ' + getDateTimeV2());
                let template_status = JSON.parse(JSON.parse(template_record.data.elasticSearchFetchDoc)).status;
                template_record = JSON.parse(JSON.parse(template_record.data.elasticSearchFetchDoc)).data;
                if (
                    parsedData &&
                    parsedData.hasOwnProperty('data') &&
                    parsedData.data &&
                    parsedData.data.hasOwnProperty('data')
                ) {
                    template_record= parsedData.data.data;
                }

                allData = template_record;
                console.log("All Records",allData);
                console.log("Template Records",template_record);
                console.log('template_record es 1', template_record);
                console.log('template_record es 1 status', template_record, template_status);
                //if document is not in elasticsearch or need to import the doc
                if(Object.keys(template_record).length == 0 || template_record.create_on_elasticsearch == 1 || doc_found){
                    console.log('template_record es x');
                    showSynching();

                    console.log('apiCallWithSubscription getDocumentWorkOrderData lambda called at ' + getDateTimeV2());
                    allData = await apiCallWithSubscription({doc_id: doc_id} ,"getDocumentWorkOrderData");
                    console.log('apiCallWithSubscription getDocumentWorkOrderData lambda response received at ' + getDateTimeV2());
                    console.log("template_record db 1: ", allData);

                    if( allData.hasOwnProperty('data') ) {
                        allData = allData.data;
                    }
                    console.log('template_record', allData);
                    console.log('template_record', allData.user_id);
                    console.log('template_record', allData.team_id);
                    console.log('template_record', doc_id);
                    let doc_data = JSON.stringify(allData);

                    console.log("template_record doc_data", doc_data);

                    if(template_status != 500){ //create on ES if ES is not down
                        try {
                            console.log('elasticSearchCreateDocOrTemp lambda called at ' + getDateTimeV2());
                            const save_elastic_es = API.graphql({
                                query: elasticSearchCreateDocOrTemp,
                                variables: {
                                    id: doc_id,
                                    index: 'prodocs-documents',
                                    template: doc_data
                                }
                            });
                            console.log('elasticSearchCreateDocOrTemp lambda response received at ' + getDateTimeV2());
                            console.log('template_record save_elastic_es', save_elastic_es);
                        } catch (err) {
                            console.error(err);
                        }
                        if(es_down_docs.length > 0){
                            let x = es_down_docs.find(d =>d.doc_id == doc_id);
                            console.log('es_down_docs x>>>', x);
                            if(x?.es_down_flag == '1'){
                                let temp_docs = es_down_docs.filter(d =>d.doc_id != doc_id);
                                console.log('es_down_docs temp_docs>>>', temp_docs);

                                let rawEs = secureLocalStorage.getItem("es_down_docs");
                                let temp_docs_temp = rawEs ? (typeof rawEs === 'string' ? JSON.parse(rawEs) : rawEs) : { body: { docs: [] } };
                                if (temp_docs_temp && temp_docs_temp.body) {
                                  temp_docs_temp.body.docs = temp_docs;
                                  secureLocalStorage.setItem('es_down_docs', JSON.stringify(temp_docs_temp));
                                }
                                //now set es flag off in db
                                console.log('setEsDownFlagDoc lambda called at ' + getDateTimeV2());
                                const set_flag_off = API.graphql({
                                    query: setEsDownFlagDoc,
                                    variables: {
                                        doc_id: doc_id,
                                        flag: '0'
                                    }
                                });
                                console.log('setEsDownFlagDoc lambda response received at ' + getDateTimeV2());
                            }
                        }
                    }
                    await saveQuantities(doc_id, doc_type_id, doc_data, allData);
                }else{
                    console.log("All Records Line 295 ",allData);
                    console.log("Template Records Line 296",template_record);
                    console.log('template_record allData', allData);

                    allData.structures = template_record.structures;
                    if(allData?.template_id && allData.template_id>0){
                        template_id = allData?.template_id;
                    }
                    if(typeof template_record.markups == 'string'){
                        allData.markups = JSON.parse(template_record.markups);
                    }else{
                        allData.markups = template_record.markups;
                    }
                    allData.notes = template_record.notes;
                    allData.options = template_record.options;
                    allData.footer = template_record.footer;
                    allData.label = template_record.label;
                    allData.team_id = template_record.team_id;
                    allData.user_id = template_record.user_id;
                    console.log('template_record str', template_record.structures);
                    console.log('template_record allDatax', allData);
                }
                template_info = {
                    "template_id": template_id,
                    "doc_type_id" : doc_type_id,
                }
                allData.doc_id = doc_id;
                let client_id = JSON.parse(secureLocalStorage.getItem("client_data")).client_id;
                let team_id = JSON.parse(secureLocalStorage.getItem("client_data")).team_id;
                let team_role = JSON.parse(secureLocalStorage.getItem('client_data')).team_role;
                let leader_id = JSON.parse(secureLocalStorage.getItem("client_data")).leader_id;

                console.log('[TEMPLATE team_id '+allData.team_id+' and CLIENT team_id '+team_id+' ]');
                console.log('template_recordz', client_id);
                console.log('template_recordz', team_id);
                console.log('[TEMPLATE team_id '+allData.team_id+' and CLIENT team_id '+team_id+' ]');

                if (team_role === 'Leader' || team_role === 'Admin') {
                    console.log(`AUTHORIZATION_ALERT_ERROR: Role is '${team_role}'. Checking if user's team (${team_id}) matches template team (${allData.team_id})...`);
                    if (allData.team_id !== team_id) {
                        console.error(`AUTHORIZATION_ALERT_ERROR: Authorization failed. ${team_role} is trying to access a template from another team.`);
                        alert('You are not authorized to access this Template.');
                        setLoading(false);
                        return false;
                    }
                } else if ((team_role === '' || team_role === null) && client_id === leader_id) {
                    console.log(`AUTHORIZATION_ALERT_ERROR: No team_role but user is leader (client_id: ${client_id}, leader_id: ${leader_id}). Checking team ownership...`);
                    if (allData.team_id !== team_id) {
                        console.error(`AUTHORIZATION_ALERT_ERROR: Authorization failed. Leader with no role is trying to access a template from another team.`);
                        alert('You are not authorized to access this Template.');
                        setLoading(false);
                        return false;
                    }
                } else {
                    console.log(`AUTHORIZATION_ALERT_ERROR: Standard user access check. Comparing template owner user_id (${allData.user_id}) with current client_id (${client_id})...`);
                    if (allData.user_id !== client_id) {
                        console.error(`AUTHORIZATION_ALERT_ERROR: Authorization failed. User ${client_id} is attempting to access a template owned by ${allData.user_id}.`);
                        alert('You are not authorized to access this Template.');
                        setLoading(false);
                        return false;
                    }
                }
            }
            else{   // will run in case of Templates (Estimate / Work Order)
                showSynching();

                console.log('elasticSearchFetchTemp lambda called at ' + getDateTimeV2());
                template_record = await API.graphql({
                    query: elasticSearchFetchTemp,
                    variables: {
                        template_id: template_id
                    }
                });
                console.log('elasticSearchFetchTemp lambda response received at ' + getDateTimeV2());

                let template_status = JSON.parse(JSON.parse(template_record.data.elasticSearchFetchTemp)).status;
                template_record = JSON.parse(JSON.parse(template_record.data.elasticSearchFetchTemp)).data;
                console.log('template_record es', template_record);
                console.log('template_record es status', template_status);

                if(Object.keys(template_record).length == 0 || temp_found){
                    showSynching();

                    console.log('getTemplate lambda called at ' + getDateTimeV2());
                    template_record = await API.graphql({
                        query: getTemplate,
                        variables: {
                            template_id: template_id
                        }
                    });
                    console.log('getTemplate lambda response received at ' + getDateTimeV2());
                    console.log("template_record db: ", template_record.data.getTemplate);
                    template_record = template_record.data.getTemplate;
                    allData = JSON.parse(template_record.data);
                    console.log('template_record allData', allData);
                    console.log('template_record allData line_items = []', allData);

                    let temp_for_elastic = allData;
                    temp_for_elastic.template_id = template_record.template_id;
                    temp_for_elastic.doc_type_id = template_record.doc_type_id;
                    temp_for_elastic.user_id = template_record.user_id;
                    temp_for_elastic.team_id = template_record.team_id;
                    temp_for_elastic.shared = template_record.shared;
                    temp_for_elastic.name = template_record.name;
                    temp_for_elastic.date_created = template_record.date_created;
                    temp_for_elastic.date_updated = template_record.date_updated;
                    temp_for_elastic.description = template_record.description;
                    temp_for_elastic.update_user_id = template_record.update_user_id;
                    temp_for_elastic.structure_count = template_record.structure_count;

                    console.log('template_record temp_for_elastic', temp_for_elastic);

                    let temp_for_elasticx = JSON.stringify(temp_for_elastic);
                    if(template_status != 500){ //create on ES if ES is not down
                        try {
                            console.log('elasticSearchCreateDocOrTemp lambda called at ' + getDateTimeV2());
                            const save_elastic_es = API.graphql({
                                query: elasticSearchCreateDocOrTemp,
                                variables: {
                                    id: template_id,
                                    index: 'prodocs-templates',
                                    template: temp_for_elasticx
                                }
                            });
                            console.log('elasticSearchCreateDocOrTemp lambda response received at ' + getDateTimeV2());
                            console.log('template_record save_elastic_es', save_elastic_es);
                        } catch (err) {
                            console.error(err);
                        }
                        if(es_down_temps.length > 0){
                            let x = es_down_temps.find(d =>d.template_id == template_id);
                            console.log('es_down_docs x>>>', x);
                            if(x?.es_down_flag == '1'){
                                let temp_docs = es_down_temps.filter(d =>d.template_id != template_id);
                                console.log('es_down_docs temp_docs>>>', temp_docs);

                                let rawEs = secureLocalStorage.getItem("es_down_docs");
                                let temp_docs_temp = rawEs ? (typeof rawEs === 'string' ? JSON.parse(rawEs) : rawEs) : { body: { temps: [] } };
                                if (temp_docs_temp && temp_docs_temp.body) {
                                  temp_docs_temp.body.temps = temp_docs;
                                  secureLocalStorage.setItem('es_down_docs', JSON.stringify(temp_docs_temp));
                                }
                                //set es flag off in db

                                console.log('setEsDownFlagTemp lambda called at ' + getDateTimeV2());
                                const set_flag_off = API.graphql({
                                    query: setEsDownFlagTemp,
                                    variables: {
                                        template_id: template_id,
                                        flag: '0'
                                    }
                                });
                                console.log('setEsDownFlagTemp lambda response received at ' + getDateTimeV2());
                            }
                        }
                    }else{
                        let flag = JSON.parse(secureLocalStorage.getItem("es_down_template_created_flag"));
                    console.log('xhandle_es_down flag>>>', flag);

                    if(typeof flag != 'undefined' && flag != '' && flag != null){
                        let rawEs = secureLocalStorage.getItem("es_down_docs");
                        let parsedEs = rawEs ? (typeof rawEs === 'string' ? JSON.parse(rawEs) : rawEs) : null;
                        let es_down_docs = parsedEs?.body?.temps || [];
                        es_down_docs.push({template_id : template_id, es_down_flag : '2'});
                        console.log('xhandle_es_down es_down_docs>>>', es_down_docs);
                        let temp_docs_temp = parsedEs || { body: { temps: [] } };

                        temp_docs_temp.body.temps = es_down_docs;
                        console.log('xhandle_es_down temp_docs_temp final>>>', temp_docs_temp);
                        secureLocalStorage.setItem('es_down_docs', JSON.stringify(temp_docs_temp));
                        console.log('setEsDownFlagTemp lambda called at ' + getDateTimeV2());
                        const set_flag_off = API.graphql({ //set es flag 2 for create in db
                            query: setEsDownFlagTemp,
                            variables: {
                                template_id: template_id,
                                flag: '2'
                            }
                        });
                        console.log('setEsDownFlagTemp lambda response received at ' + getDateTimeV2());
                        secureLocalStorage.removeItem('es_down_template_created_flag');
                        console.log('xhandle_es_down flag>>>', flag);
                    }
                }
            }else{
                console.log('template_record allData', allData);
                allData = template_record;
                if(typeof template_record.markups == 'string'){
                    allData.markups = JSON.parse(template_record.markups);
                }else{
                    allData.markups = template_record.markups;
                }
                // allData.structures = template_record.structures;
                // allData.markups = template_record.markups;
                // allData.notes = template_record.notes;
                // allData.options = template_record.options;
                // allData.footer = template_record.footer;
                // allData.label = template_record.label;
                // console.log('template_record str', template_record.structures);
                console.log('template_record allDatax', allData);
            }

            template_info = {
                "template_id": template_record.template_id,
                "doc_type_id" : template_record.doc_type_id,
                "user_id" : template_record.user_id,
                "team_id" : template_record.team_id,
                "name": template_record.name,
                "description": template_record.description,
                "date_created": template_record.date_created,
                "date_updated": template_record.date_updated,
            };

            let client_id = JSON.parse(secureLocalStorage.getItem("client_data")).client_id;
            let team_id = JSON.parse(secureLocalStorage.getItem("client_data")).team_id;
            let team_role = JSON.parse(secureLocalStorage.getItem('client_data')).team_role;
            let leader_id = JSON.parse(secureLocalStorage.getItem("client_data")).leader_id;

            console.log('template_recordx', template_record.user_id);
            console.log('template_recordx', template_record.team_id);
            console.log('template_recordz', client_id);
            console.log('template_recordz', team_id);

            if (template_record.user_id !== client_id) {
                console.log(`AUTHORIZATION_ALERT_ERROR [template.js:504]: User mismatch. Template owner (user_id: ${template_record.user_id}) does not match current client (client_id: ${client_id}). Fetching permissions...`);
                
                showSynching();
                
                console.log(`AUTHORIZATION_ALERT_ERROR [template.js:508]: getClientByID lambda called at ${getDateTimeV2()}`);
                
                const result = await API.graphql({
                    query: getClientByID,
                    variables: {
                        client_id: template_record.user_id
                    }
                });
            
                console.log(`AUTHORIZATION_ALERT_ERROR [template.js:517]: getClientByID lambda response received at ${getDateTimeV2()}`);
                console.log(`AUTHORIZATION_ALERT_ERROR [template.js:518]: getClientByID result:`, result?.data?.getClientByID);
            
                let edit_res = result?.data?.getClientByID?.pd_team_edit;
                console.log(`AUTHORIZATION_ALERT_ERROR [template.js:521]: pd_team_edit value:`, edit_res);
                
                console.log('[TEMPLATE team_id '+allData.team_id+' and CLIENT team_id '+team_id+' ]');
                if (edit_res == 0) {
                    console.error(`AUTHORIZATION_ALERT_ERROR [template.js:524]: Authorization failed. User is not permitted to edit this template (pd_team_edit = 0).`);
                    alert('You are not authorized to access this Template.');
                    setLoading(false);
                    return false;
                }
            }
            console.log('[TEMPLATE team_id '+allData.team_id+' and CLIENT team_id '+team_id+' ]');
            if (team_role === 'Leader' || team_role === 'Admin') {
                console.log(`AUTHORIZATION_ALERT_ERROR [template.js:531]: Role is '${team_role}'. Checking if user's team (${team_id}) matches template's team (${template_record.team_id})...`);
                if (template_record.team_id !== team_id) {
                    console.error(`AUTHORIZATION_ALERT_ERROR [template.js:533]: Authorization failed. ${team_role} is trying to access a template from another team.`);
                    alert('You are not authorized to access this Template.');
                    setLoading(false);
                    return false;
                }
            } else if ((team_role === '' || team_role === null) && client_id === leader_id) {
                console.log(`AUTHORIZATION_ALERT_ERROR [template.js:538]: No team_role but user is leader (client_id: ${client_id}, leader_id: ${leader_id}). Checking if user's team (${team_id}) matches template's team (${allData.team_id})...`);
                if (allData.team_id !== team_id) {
                    console.error(`AUTHORIZATION_ALERT_ERROR [template.js:540]: Authorization failed. Leader with no role is trying to access a template from another team.`);
                    alert('You are not authorized to access this Template.');
                    setLoading(false);
                    return false;
                }
            } else {
                console.log(`AUTHORIZATION_ALERT_ERROR [template.js:545]: Standard user access check. Comparing template owner user_id (${template_record.user_id}) with current client_id (${client_id})...`);
                if (template_record.user_id !== client_id) {
                    console.error(`AUTHORIZATION_ALERT_ERROR [template.js:547]: Authorization failed. User ${client_id} is attempting to access a template owned by ${template_record.user_id}.`);
                    alert('You are not authorized to access this Template.');
                    setLoading(false);
                    return false;
                }
            }
           
        }//will run in case of Templates (Estimate / Work Order)

        console.log("template_info for redux: " , template_info);
        dispatch({ type: "TEMPLATE_INFO", value: template_info });

        // allData = (template_id == 0 ) ? JSON.parse(template_record.data.getDocumentWorkOrderData) : JSON.parse(template_record.data);
        console.log("allData for redux: " , allData);
        dispatch({ type: "TEMPLATE_STRUCTURE", value: allData });
        console.log("end of function");
        
        console.log("Final Data >> ",allData)
        secureLocalStorage.setItem("finalDataDocOrTemp",JSON.stringify(allData));

        if(doc_id && (!url_params.is_template || url_params.is_template === "0"))
        {
            console.log("its a Document (Not template)");
            setLoading2(true);
            console.log("setLoading2 true in fetchTemplateRecord in template.js at " + getDateTimeV2());
        }
        } catch (err) {
            console.error("Error in fetchTemplateRecord:", err);
        } finally {
            setLoading(false);
            console.log("setLoading false in fetchTemplateRecord finally in template.js at " + getDateTimeV2());
        }
    }

    async function saveQuantities(doc_id, doc_type_id, doc_data, allData) {
        
        showSynching();

        console.log('getDocOrderIds lambda called at ' + getDateTimeV2());
        const getDocOrders = await API.graphql({
            query: getDocOrderIds,
            variables: {
                doc_id: doc_id
            }
        });
        console.log('getDocOrderIds lambda response received at ' + getDateTimeV2());
        
        let ordersData = JSON.parse(getDocOrders.data.getDocOrderIds);
        
        let scopeIds = [];
        for(const order of ordersData) {
            scopeIds.push(order.scope_id);
        }

        if(scopeIds.length > 0) {
            showSynching();

            console.log('addDocOrders lambda called at ' + getDateTimeV2());
            const addQuantities = await API.graphql({
                query: addDocOrders,
                variables: {
                    doc_id: doc_id,
                    doc_type_id : doc_type_id, 
                    scope_ids: scopeIds.join(','),
                    data: doc_data,
                    token: secureLocalStorage.getItem("user_token"),
                    action: 'legacy'
                }
            });
            console.log('addDocOrders lambda response received at ' + getDateTimeV2());
            
            const response = JSON.parse(addQuantities.data.addDocOrders);
            if(response.statusCode === 200) {
                allData.quantities = response.quantities; 
            }
        }
    }

    async function fetchUnits() {
        console.log("fetchUnits");
        showSynching();

        console.log('getUnits lambda called at ' + getDateTimeV2());
        const default_units = await API.graphql({
            query: getUnits
        })
        console.log('getUnits lambda response received at ' + getDateTimeV2());

        console.log("default_units: ", default_units);

        // set default categories to redux
        let d_units = default_units.data.getUnits;
        let temp_unit = {};
        temp_unit.unit_id=0;
        temp_unit.name='';
        temp_unit.label='(None)';
        d_units.unshift(temp_unit);
        console.log("default_units: ", d_units);
        dispatch({ type: "DEFAULT_UNITS", value: d_units });
    }

    async function fetchCategories() {
        let client_id = JSON.parse(secureLocalStorage.getItem('client_data')).client_id;
        let team_id = JSON.parse(secureLocalStorage.getItem('client_data')).team_id;
        console.log("client_id: ", client_id);
        console.log("team_id: ", team_id);
        showSynching();

        console.log('getCategoryByUserID lambda called at ' + getDateTimeV2());
        const userCategories = await API.graphql({
            query: getCategoryByUserID,
            variables: {
                user_id: client_id,
                team_id: team_id
            }
        });
        console.log('getCategoryByUserID lambda response received at ' + getDateTimeV2());

        showSynching();

        console.log('getCategoriesWithLineitemsRedis lambda called at ' + getDateTimeV2());
        const rd_categories = await API.graphql({
            query: getCategoriesWithLineitemsRedis,
            variables: {
                id: 1
            }
        });
        console.log('getCategoriesWithLineitemsRedis lambda response received at ' + getDateTimeV2());

        console.log('rd_categories>', rd_categories);
        let rd_categoriesx = JSON.parse(rd_categories.data.getCategoriesWithLineitemsRedis);
        let rd_categoriesxx = JSON.parse(rd_categoriesx.body);
        (rd_categoriesxx || []).forEach(category => {
            category.e_line_items = [];
        }); // remove category default line items
        console.log('rd_categories>', rd_categoriesxx);

        if(!rd_categoriesxx){
            showSynching();

            console.log('getDefaultCategories lambda called at ' + getDateTimeV2());
            const d_categories = await API.graphql({
                query: getDefaultCategories
            });
            console.log('getDefaultCategories lambda response received at ' + getDateTimeV2());

            // set default categories to redux
            let d_cat = default_category;
            d_cat = d_categories.data.getDefaultCategories;
            dispatch({ type: "DEFAULT_CATEGORIES", value: d_cat });
            console.log("setUserDefaultCategory: ", d_categories.data.getDefaultCategories);

            // set user categories to redux
            let cat_by_userid = category_by_user_id;
            cat_by_userid = userCategories.data.getCategoryByUserID;
            dispatch({ type: "CATEGORIES_BY_USERID", value: cat_by_userid });

            console.log("setUserCategory: ", userCategories);
            setUserDefaultCategory(d_categories.data.getDefaultCategories);
            setUserCategory(userCategories.data.getCategoryByUserID);
        }else{
            //rd_categoriesxx // remove line items.

            dispatch({ type: "DEFAULT_CATEGORIES", value: rd_categoriesxx });

            // set user categories to redux
            let cat_by_userid = category_by_user_id;
            cat_by_userid = userCategories.data.getCategoryByUserID;
            dispatch({ type: "CATEGORIES_BY_USERID", value: cat_by_userid });

            console.log("setUserCategory: ", userCategories);
            setUserDefaultCategory(rd_categoriesxx);
            setUserCategory(userCategories.data.getCategoryByUserID);
        }
    }

    async function fetchDefaultManufacturer() { // redis
        if(url_params.doc_type_id == 2 || typeof url_params.doc_type_id == 'undefined'){
            let team_id = JSON.parse(secureLocalStorage.getItem("client_data")).team_id;
            showSynching();

            console.log('getUsersManufacturers lambda called at ' + getDateTimeV2());
            const user_man = await API.graphql({
                query: getUsersManufacturers,
                variables: {
                    team_id: team_id
                }
            });
            console.log('getUsersManufacturers lambda response received at ' + getDateTimeV2());

            let user_man_data = JSON.parse(user_man.data.getUsersManufacturers);
            console.log('fetchDefaultManufacturer user_man>', user_man_data);
            let temp_user_man_data = [];
            user_man_data.map( function(d_manufecturer, i) {
                temp_user_man_data.push({
                    'value' : d_manufecturer.manufacturer_id,
                    'label' : d_manufecturer.name
                });
            });
            setUserManufacturers(temp_user_man_data);
        }
        showSynching();

        console.log('getDefaultManufacturersRedis lambda called at ' + getDateTimeV2());
        const dr_man = await API.graphql({
            query: getDefaultManufacturersRedis,
            variables: {
                id: 1
            }
        });
        console.log('getDefaultManufacturersRedis lambda response received at ' + getDateTimeV2());

        let dr_manx = JSON.parse(dr_man.data.getDefaultManufacturersRedis);
        console.log('fetchDefaultManufacturer dr_man', dr_manx.body);
        console.log('fetchDefaultManufacturer dr_man', typeof dr_manx.body);

        if(dr_manx.body == null){
            showSynching();
            const d_man = await API.graphql({
                query: getDefaultManufacturer,
            });
    
            let default_manufecturer = d_man.data.getDefaultManufacturer;
            var temp_default_manufecturer = [];
            default_manufecturer.map( function(d_manufecturer, i) {
                temp_default_manufecturer.push({
                    'value' : d_manufecturer.manufacturer_id,
                    'label' : d_manufecturer.name
                });
            });
            setDefaultManufacturers(temp_default_manufecturer);

            console.log('fetchDefaultManufacturer if', temp_default_manufecturer);
    
            // set default manufecturer to redux
            let d_manu = d_manf;
            d_manu = temp_default_manufecturer;
            dispatch({ type: "MANUFECTURER", value: d_manu });
        }else{
            let default_manufecturer = JSON.parse(dr_manx.body);
            var temp_default_manufecturer = [];
            default_manufecturer.map( function(d_manufecturer, i) {
                temp_default_manufecturer.push({
                    'value' : d_manufecturer.manufacturer_id,
                    'label' : d_manufecturer.name
                });
            });
            console.log('fetchDefaultManufacturer else', temp_default_manufecturer);
            setDefaultManufacturers(temp_default_manufecturer);
            dispatch({ type: "MANUFECTURER", value: temp_default_manufecturer });
        }

        
    }

    return (
        <>
         <Helmet>
                <meta charSet="utf-8" />
                <title>Prodocs</title>
                <link rel="canonical" href="/prodocs-logo.png" />
            </Helmet>
        { loading2 && !loading && 
        <LoadingContainer>
            <img className="loader" src={Loader}/>
        </LoadingContainer>
        }
        { loading ?
            <LoadingContainer>
                <img className="loader" src={Loader}/>
            </LoadingContainer>

        :
            <Template>
                { Array.isArray(defaultCategory) && defaultCategory.length && Array.isArray(userCategory) && Array.isArray(defaultManufacturers) && defaultManufacturers.length ? 
                    <>
                        {
                            show &&
                            <ToastBox
                            setShow={setShow}
                            show={show}
                            Text={showMessage}
                            Type={showMessageType}
                            />
                        }
                        <CreateTemplate
                            setLoading={setLoading}
                            setLoading2={setLoading2}
                            fetchTemplateRecord={fetchTemplateRecord}
                            url_params={url_params}
                            defaultManufacturers={defaultManufacturers}
                            userManufacturers={userManufacturers}
                            setUserManufacturers={setUserManufacturers}
                            prevState={prevState}
                            show={show}
                            showMessage={showMessage}
                            showMessageType={showMessageType}
                            setShow={setShow}
                            setShowMessage={setShowMessage}
                            setShowMessageType={setShowMessageType}
                        />
                    </>
                    : 
                    <></>
                }
            </Template>
        }
        {synching && <img className="sync" src={Sync} />}
        </>
    )
}

const LoadingContainer = styled.div`
    height:100vh;
    width:100%;
    display:flex;
    align-items:center;
    justify-content:center;
    background: transparent;
    .loader{
        -webkit-user-select: none;
        margin: auto;
        // background-color: rgba(255,255,255, 0.5);
        // transition: background-color 300ms;
    }
`

const Template = styled.div`
    // padding-top: 112px;
    position: relative;
    box-sizing: border-box;
    min-height: 100%;
    width: 100%;
    overflow: hidden;
    // padding: 5em 0 6.5em 0;
`
